import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';

import { Observable } from 'rxjs';
import { UserVoluntaryService } from '../../user/user-voluntary.service';
import { VoluntaryModel } from '../../models/voluntary.model';

@Injectable({ providedIn: 'root' })
export class AuthVoluntaryGuard implements CanActivate {
  constructor(
    private userVoluntaryService: UserVoluntaryService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (
      !this.userVoluntaryService.isLogged() ||
      this.userVoluntaryService.isTokenExpired() ||
      !this.userVoluntaryService.hasRole('ROLE_VOLUNTARY')
    ) {
      this.router.navigate(['/auth-voluntary/login'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }

    return true;
  }
}
